import AssetThumbnail from '@admin/components/asset_thumbnail'
import PropTypes from 'prop-types'
import React from 'react'

const AssetToken = (asset) => (
  <div className="maha-token asset">
    <div className="maha-token-image">
      <AssetThumbnail { ...asset } />
    </div>
    <div className="maha-token-details">
      { asset.original_file_name }
    </div>
  </div>
)

AssetToken.propTypes = {
  original_file_name: PropTypes.string
}

export default AssetToken
